// extracted by mini-css-extract-plugin
export var hidden = "points-notification-module--hidden--MRrwi";
export var pointNotificationFlash = "points-notification-module--point-notification-flash--I3skf";
export var pointNotificationIn = "points-notification-module--point-notification-in--zSLNc";
export var pointsNotification = "points-notification-module--points-notification--begj3";